// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Фінанси депутата» (MP Finance, ключ `mpf`, група `office`). */
export const mpFinanceManifest: IModuleManifest = {
  key: 'mpf',
  group: 'office',
  slug: 'mp-finance',
  prefix: 'MPF',
  name: { en: 'MP Finance', uk: 'Фінанси депутата' },
  entities: [
    { key: 'mpf', slug: 'mpf', name: { en: 'Budget lines', uk: 'Бюджетні статті' }, main: true },
    { key: 'mpfexp', slug: 'mpfexp', name: { en: 'Expenses', uk: 'Видатки' }, main: false },
    { key: 'mpfpay', slug: 'mpfpay', name: { en: 'Assistant pay', uk: 'Оплата помічників' }, main: false },
    { key: 'mpfdec', slug: 'mpfdec', name: { en: 'Declarations', uk: 'Декларації' }, main: false },
  ],
  loadState: () => import('./state/mpFinanceSlice').then((m) => m.mpFinanceSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
